import { NumberField, TextField, TextFieldProps } from '@scaleaq/scaleui';
import { Control, Controller, FieldValues, Path, RegisterOptions } from 'react-hook-form';

type ControlledTextOrNumberFieldProps<T extends TextFieldProps> = {
  control: Control<T>;
  caution?: boolean | string;
  critical?: boolean | string;
  decimals?: number;
  inputType?: 'text' | 'number';
  maxWidth?: string;
  name: Path<T>;
  render?: boolean;
  rules?: Omit<
    RegisterOptions<T, Path<T>>,
    'valueAsNumber' | 'valueAsDate' | 'setValueAs' | 'disabled'
  >;
} & Omit<TextFieldProps, 'value' | 'onChange' | 'pattern' | 'type' | 'defaultValue'>;

export const ControlledTextOrNumberField = <T extends FieldValues>({
  control,
  caution,
  critical,
  name,
  render = true,
  rules,
  inputType = 'text',
  inForm = true,
  ...props
}: ControlledTextOrNumberFieldProps<T>) => {
  if (!render) return;

  return (
    <div style={{ maxWidth: props.maxWidth, width: '100%' }}>
      <Controller
        control={control}
        name={name}
        rules={rules}
        render={({ field }) =>
          inputType === 'text' ? (
            <TextField
              {...props}
              inForm={inForm}
              value={field.value ?? ''}
              onChange={field.onChange}
              caution={caution}
              critical={critical}
            />
          ) : (
            <NumberField
              {...props}
              inForm={inForm}
              value={
                field.value !== undefined && field.value !== null ? Number(field.value) : undefined
              }
              onChange={field.onChange}
              caution={caution}
              critical={critical}
              style={{ ...props.style, textAlign: 'left' }}
            />
          )
        }
      />
    </div>
  );
};
